// apps/web/src/lib/compras/permissao.ts — Fase 13, Plano 19 (COMP-02, T-13-19A).
// Permissão exigida por rota de Compras que só faz sentido para quem escreve. É ergonomia: o servidor continua a barreira
// real (403), a guarda só evita preencher o formulário inteiro para descobrir que não pode.

export const PERMISSAO_ROTA_COMPRAS: Readonly<Record<string, string>> = {
  '/compras/pedidos/novo': 'compras:gerenciar',
};
